import TrackingApiEntity from '@/interfaces/TrackingApiEntity.interface';
import moment from 'moment';
import Parseable from '@/misc/Parseable';
import TrackingPage from '@/interfaces/Page.interface';

/**
 * Defines the tracking data structure for one reading session
 */
export default class Tracking extends Parseable {

    private API_DATE_FORMAT: string = 'YYYY-MM-DD HH:mm:ss';

    public locationId!: string;
    public publicationId!: string;
    public magazineId!: string;
    public readerId!: string;
    public publisherId!: string;
    /**
     * ISO8601 date format
     */
    public readSessionStart!: string;
    /**
     * ISO8601 date format
     */
    public readSessionEnd!: string;
    /**
     * All pages that were read during the reading session.
     * Be aware of the page structure: page: "1" or page: "12"
     * And be aware of the readPageStart and readPageEnd structure: Use ISO8601 date format
     */
    public pages: TrackingPage[] = [];

    /**
     * Return the Tracking object as TrackingApiEntity for api usage
     */
    get apiRepresentation(): TrackingApiEntity {
        return {
            id_hotspot: this.locationId,
            id_magazine_publication: this.publicationId,
            id_magazine: this.magazineId,
            id_reader: this.readerId,
            id_publisher: this.publisherId,
            pages: this.pages.map(item => {
                return {
                    page: item.page,
                    read_beginning: moment(item.readPageStart).format(this.API_DATE_FORMAT),
                    read_ending: moment(item.readPageEnd).format(this.API_DATE_FORMAT)
                };
            }),
            read_beginning: moment(this.readSessionStart).format(this.API_DATE_FORMAT),
            read_ending: moment(this.readSessionEnd).format(this.API_DATE_FORMAT)
        };
    }

    public static parseFromObject(rawObject: any): Tracking {
        const tracking = new Tracking();
        tracking.locationId = rawObject.locationId;
        tracking.readerId = rawObject.readerId;
        tracking.API_DATE_FORMAT = rawObject.API_DATE_FORMAT;
        tracking.magazineId = rawObject.magazineId;
        tracking.publicationId = rawObject.publicationId;
        tracking.publisherId = rawObject.publisherId;
        tracking.readSessionStart = rawObject.readSessionStart;
        tracking.readSessionEnd = rawObject.readSessionEnd;

        tracking.pages = rawObject.pages.map((data: any) => {
            return {
                page: data.page,
                readPageStart: data.readPageStart,
                readPageEnd: data.readPageEnd,
                splitMode: data.splitMode
            };
        });

        return tracking;
    }

    public parseToObject(): Partial<Tracking> {
        return { ...this };
    }
}
